require('expose-loader?SportsbookBetslip!../../src/app/sportsbook/betslip');
